// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__h0eKE","author":"Table_author__1ar2n","authorImage":"Table_authorImage__1xYOh","unreadRow":"Table_unreadRow__1sko4"};